<template>
<div class="z-main">
    <header class="z-header" style="border-bottom:0px;box-shadow: 0 1px 5px #515151;">
        <div style="font-size:22px;font-family: Source Han Sans CN;font-weight: bold;">
            {{$t('行情')}}
        </div>
        <div></div>
        <div></div>
    </header>
	<div class="z-body" :style="{height:(windowHeight-100)+'px'}">
		<!-- 列表表头 -->
	    <div class="z-flex z-Hq-list-th">
	      <div style="width: 30%;">{{$t('名称')}}</div>
	      <div style="width: 30%;text-align:center;">{{$t('价格')}}</div>
	      <div style="width: 20%;">{{$t('今日涨跌幅')}}</div>
	    </div>
	    <!-- 列表数据 -->
	    <div class="z-flex z-Hq-list">

	      <template v-for="(item,index) in list">
	        <router-link class="z-flex z-Hq-list-a" :id="'hq'+item.id" :to="{path:'/futures/kline',query:{id:item.id,fid:item.id,is_main:item.is_main,fname:item.title,symbol:item.symbol,code:item.symbol,api:2,from:'index'}}">
	          <div class="dark-color" v-text="item.title"></div>
	          <div>
	            <span style="color:#70757D;font-size:12px;" v-text="item.price"></span>
	          </div>
	          <div :style="{background:item.zfrate>0 ? kStyle.up.color : kStyle.down.color}" v-text="item.zfrate>0 ? '+'+item.zfrate+'%' : item.zfrate+'%'"></div>
	        </router-link>
	      </template>

	    </div>
	</div>
	<!-- 底部菜单 -->
	<ButtomMenu active="1"/>
</div>
</template>

<script>
import ButtomMenu from '../components/ButtomMenu'
export default {
	name: 'market',
	data() {
		return {
			data:[],
			//上拉下拉
			mescroll: null,
			list:[],
			token:'',
			symbols:[],
			eventInterval:null,

      		isShowDeal:false
		}
	},
	components: {
		ButtomMenu
	},
	created() {
		let _this = this
	},
	mounted() {
		// this.mescrollInit()
		let _this = this
		if(window.localStorage.token){
			_this.token=window.localStorage.token
		}
		this.init()
	},
	methods: {
		init(){
			let _this = this
			_this.get('api/Futures/getShortList',{page:1}).then((res)=>{
				let data = res.data
				_this.list = data
				for(var i=0;i<data.length;i++){
					_this.symbols.push(data[i].symbol)
					// let item = data[i].list
					// for(let j=0;j<item.length;j++) {
					// 	_this.symbols.push(item[j].symbol)
					// }
				}
				//长连接 - 检测和接收数据
				_this.wsCheck()
			})
		},
		wsCheck(){ //长连接 - 检测状态后数据接收
			let _this = this;
			//长连接状态正常才发送
			if (_this.$store.state.webscoketObj && _this.$store.state.webscoketObj.readyState==1) {
				clearInterval(_this.eventInterval)
				_this.$create_wsConfig(_this,_this.symbols.join(','),_this.token,0)
				_this.$store.state.webscoketObj.onmessage = _this.processData
			}
			else { //长连接状态不正常，则轮询
				_this.eventInterval = setInterval(function () {
					clearInterval(_this.eventInterval)
					_this.wsCheck()
				},1000)
			}
		},
		processData(e) {
        let _this = this
        var rs = JSON.parse(e.data);
        if (rs.type == 'hangqing') {
          let data = rs.data[0];
          let list = _this.list;
          for (let i = 0; i < list.length; i++) {
            let item = list[i];
            if (item.id == data.fid) {
              _this.list[i]['zfrate'] = data.zfrate
              _this.list[i]['price'] = data.last_price
              break;
            }
          }
        }
      },
		// mescroll组件初始化的回调,可获取到mescroll对象
		// mescrollInit () {
		// 	let _this = this;
		// 	_this.mescroll = new MeScroll("z-market-mescroll",{
		// 		up:{
		// 			callback: _this.upCallback
		// 		}
		// 	})
		// },
		// // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
		// upCallback (page, mescroll) {
		// 	let _this = this
		// 	_this.getList(page.num,function (rs) {

		// 	})
		// },
		// getList(pageIndex,callback){
		// 	let _this = this
		// 	// 联网请求
		// 	this.get('api/index/trades', {
		// 		page: pageIndex, // 页码
		// 		limit: 15 // 每页长度
		// 	}).then((rs) => {
		// 		let arr = rs.data.data
		// 		// 如果是第一页需手动置空列表
		// 		if (pageIndex === 1) {
		// 			_this.data = []
		// 		}

		// 		if (arr.length == 0)
		// 		{
		// 			_this.$store.commit('layer','暂无数据')
		// 		}
		// 		else {
		// 			// 把请求到的数据添加到列表
		// 			_this.data = _this.data.concat(arr)
		// 		}
		// 		callback && callback(rs)
		// 		// 数据渲染成功后,隐藏下拉刷新的状态
		// 		_this.$nextTick(() => {
		// 			_this.mescroll.endSuccess(arr.length)
		// 		})

		// 	}).catch((e) => {
		// 		// 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
		// 		_this.mescroll.endErr()
		// 	})
		// },
    // close(){
      // this.isShowDeal = false
    // }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.z-market-item {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
	padding: 10px;
	/* border-bottom: 1px solid #27292F; */
  border-bottom: 1px solid #515151;
}
.z-market-info {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
}
.z-market-user-info div:nth-child(2) {
	font-size: 10px;
	color: #9B9A9C;
}
.z-market-user-avatar {
	width: 36px;
	height: 36px;
	border-radius: 5px;
	margin-right: 10px;
}
.z-icon {
	width: 18px;
	height: 18px;
}

.z-Hq-list-th {
    justify-content: space-between;
    padding: 5px 10px;
    color: #7C8086;
    font-size: 12px;
    padding: 10px 10px;
  }

  .z-Hq-list-item-title {
    color: #7C8086;
    font-size: 16px;
    align-self: flex-start;
    background: #1C2023;
    padding: 5px 10px;
    border-radius: 10px;
  }

  .z-Hq-list-title {
    padding: 10px;
    color: #E2B96F;
    border-bottom: 1px solid #2f2b2b;
  }

  .z-Hq-list {
    flex-direction: column;
    margin-bottom: 30px;
  }

  .z-Hq-list-a {
    width: 100%;
    padding: 10px 10px;
    justify-content: space-between;
    border-bottom: 1px solid #515151;
    text-align: center;
  }

  .z-Hq-list-a div:nth-child(1) {
  	width: 30%;
    text-align: left;
    color: white;
  }

  .z-Hq-list-a div:nth-child(2) {
    width: 30%;
    color: #00C087;
  }

  .z-Hq-list-a div:nth-child(3) {
    width: 20%;
    color: white;
    padding: 5px 8px;
    border-radius: 2px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market.vue